// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import { mobileView } from '../_common/api/utility';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 90%;
    background: ${({ mobile, color }) => mobile ? color : ''};

    ${({ image }) => image && `
        background-image: url(${image});
        position: relative;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        min-width: 100vw;
        height: 100%;

        z-index: 1;
    `}
`
const ZWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 3;
`
const Headline = styled.span`
    font-size: 2.5em;
    color: ${({ theme }) => theme.carouselTitle};
    text-align: center;
    font-weight: bold;
`
const Text = styled.span`
    font-size: 1.5em;
    text-align: center;
    color: ${({ theme }) => theme.white};
`

const Shade = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    background: #00000080;
    display: flex;
    align-items: flex-end;
    z-index: 2;
`;

const CarouselCard = ({ headline, text, button, image, color, ...props }) => {
    return (
        <Wrapper mobile={mobileView} image={mobileView ? image : false} color={color}>
            {mobileView ? <Shade /> : null}
            <ZWrap>
                <Headline>{headline}</Headline>
                <Text>{text}</Text>
                {button}
            </ZWrap>
        </Wrapper>
    );
}

export default CarouselCard;